import { Injectable } from '@angular/core';

import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { UrlHelperService } from '../../navigation-core/url-helper.service';
import { PrintService } from '../../print/print.service';

@Injectable({ providedIn: 'root' })
export class MyBetsPrintService {
    constructor(
        private printService: PrintService,
        private urlHelper: UrlHelperService,
        private tracker: TrackingService,
    ) {}

    printMyBetsSingleCard(betslipId: string, associatedAccount: Nullable<string>): void {
        const url = this.getPrintMyBetsSingleCardUrl(betslipId, associatedAccount);
        this.printService.print(url);
        this.track('Print Bet Card');
    }

    printMyBets(fromDate?: Date, toDate?: Date, betState?: string, associatedAccount: Nullable<string> = null): void {
        const url = this.getPrintMyBetsUrl(fromDate, toDate, betState, associatedAccount);
        this.printService.print(url);
        this.track('Print All');
    }

    printEditMyBetsHistory(betslipId: string, associatedAccount: Nullable<string>): void {
        const url = this.getPrintEditMyBetsHistoryUrl(betslipId, associatedAccount);
        this.printService.print(url);
        this.track('Print Edit History');
    }

    private getPrintMyBetsSingleCardUrl(betslipId: string, associatedAccount: Nullable<string>): string {
        const builder = this.urlHelper.getPrintUrlBuilder();
        builder.appendQuery({ betNumber: betslipId });
        if (associatedAccount) {
            builder.appendQuery({ associatedAccount });
        }

        const url = this.urlHelper.getAbsolute(builder.toString());

        return url;
    }

    private getPrintMyBetsUrl(fromDate?: Date, toDate?: Date, betState?: string, associatedAccount: Nullable<string> = null): string {
        const builder = this.urlHelper.getPrintUrlBuilder();

        if (fromDate) {
            builder.appendQuery({ fromDate: fromDate.toISOString() });
        }

        if (toDate) {
            builder.appendQuery({ toDate: toDate.toISOString() });
        }

        if (betState) {
            builder.appendQuery({ betState });
        }

        if (associatedAccount) {
            builder.appendQuery({ associatedAccount });
        }

        const url = this.urlHelper.getAbsolute(builder.toString());

        return url;
    }

    private track(positionEvent: string): void {
        this.tracker.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Print Bet',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'Print Bet',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Print - Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: positionEvent,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }

    private getPrintEditMyBetsHistoryUrl(betslipId: string, associatedAccount: Nullable<string>): string {
        const builder = this.urlHelper.getPrintUrlBuilder();
        builder.append('edit-my-bet-history');
        builder.appendQuery({ betnumber: betslipId });

        if (associatedAccount) {
            builder.appendQuery({ associatedAccount });
        }

        const url = this.urlHelper.getAbsolute(builder.toString());

        return url;
    }
}
